import type { RoomLayoutGenerator } from "./roomLayout";

const roomLayoutGarage: RoomLayoutGenerator[] = [];

export default roomLayoutGarage;
